'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger, InputGroupAddon, InputGroupButton } from '@repo/ui/components/start';
import { CheckIcon, CopyIcon } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { usePhoneInput } from './context';
export function PhoneInputCopyMenu() {
  const $ = _c(24);
  const {
    actions,
    state
  } = usePhoneInput();
  const {
    copied,
    disabled,
    formats,
    inputVariant,
    layout
  } = state;
  if (disabled || formats.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== copied) {
    t0 = copied ? <CheckIcon className="size-3.5" /> : <CopyIcon className="size-3.5" />;
    $[0] = copied;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const trigger = t0;
  let t1;
  if ($[2] !== inputVariant || $[3] !== layout) {
    t1 = layout === "input-group" ? <InputGroupButton aria-label="Copy phone number" type="button" variant={inputVariant} /> : <Button aria-label="Copy phone number" className={cn("px-2", inputVariant === "ghost" && "opacity-0 transition-opacity group-focus-within/phone-input:opacity-100 group-hover/phone-input:opacity-100")} type="button" variant={inputVariant === "ghost" ? "ghost" : "outline"} />;
    $[2] = inputVariant;
    $[3] = layout;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1 || $[6] !== trigger) {
    t2 = <DropdownMenuTrigger render={t1}>{trigger}</DropdownMenuTrigger>;
    $[5] = t1;
    $[6] = trigger;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenuLabel>Copy phone number</DropdownMenuLabel>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== actions || $[10] !== formats) {
    let t5;
    if ($[12] !== actions) {
      t5 = format => <DropdownMenuItem key={format.label} onClick={() => actions.copy(format.value)}>{format.value}</DropdownMenuItem>;
      $[12] = actions;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = formats.map(t5);
    $[9] = actions;
    $[10] = formats;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <DropdownMenuContent align="end">{t3}<DropdownMenuGroup>{t4}</DropdownMenuGroup></DropdownMenuContent>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t2 || $[17] !== t5) {
    t6 = <DropdownMenu>{t2}{t5}</DropdownMenu>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const menu = t6;
  if (layout === "input-group") {
    const t7 = inputVariant === "ghost" && "opacity-0 transition-opacity group-focus-within/input-group:opacity-100 group-hover/input-group:opacity-100";
    let t8;
    if ($[19] !== t7) {
      t8 = cn(t7);
      $[19] = t7;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] !== menu || $[22] !== t8) {
      t9 = <InputGroupAddon align="inline-end" className={t8}>{menu}</InputGroupAddon>;
      $[21] = menu;
      $[22] = t8;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    return t9;
  }
  return menu;
}